export default function LimitIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="16" height="16" rx="3" stroke="currentColor" strokeWidth="2" />
      <rect x="7.5" y="13.5" width="1" height="3" rx="0.5" fill="white" stroke="currentColor" />
      <rect x="11.5" y="8.5" width="1" height="8" rx="0.5" fill="white" stroke="currentColor" />
      <rect x="15.5" y="11.5" width="1" height="5" rx="0.5" fill="white" stroke="currentColor" />
    </svg>
  );
}
